export const STATUS_SUCCESS = 999;
export const STATUS_OK = 200;
export const STATUS_UNAUTHORIZED = 401;
export const STATUS_NOTFOUND = 404;
export const STATUS_INTERNALSERVERERROR = 500;